import "./UpdateProgress.css";

export const UpdateProgress = () => {
  return (
    <div className="UpdateProgress">
      <h1>Update Progress</h1>
    </div>
  );
};
